import { useRef, useEffect } from "react";
import { useAttribute } from "lib/hooks";

export default function Checkbox({ name }) {
  const ref = useRef();
  const [draggable, setDraggable] = useAttribute("draggable");
  const onChange = (e) => {
    setDraggable(e.target.checked);
  };
  useEffect(() => {
    ref.current.checked = draggable;
  }, [draggable]);
  return (
    <div>
      <label className="cb">
        <input type="checkbox" {...{ ref, onChange }} />
        <span>{name}</span>
      </label>
    </div>
  );
}
